import React, { useEffect } from 'react';

import { useKioskPro } from 'src/hooks/use-kiosk-pro';
import { KioskProLockScreen } from 'src/components/kiosk-pro/lock-screen';
import { LockScreen } from 'src/components/lock-screen';
import { useKioskLiveness } from 'src/hooks/use-kiosk-liveness';
import { Session } from 'utils/session/session';
import useCart from 'shared/hooks/use-cart';

// ECOMM-12178: `/lock` is a standalone route, not wrapped by `CoreMenuLayout`, so it fires the
// liveness ping itself -- see `useKioskLiveness`. The PIN is optional and never gates this route
// (see /kiosks/[cName]/setup).
export default function LockPage(): JSX.Element {
  const isKioskProEnabled = useKioskPro();
  const Cart = useCart();

  useKioskLiveness();

  // Explicitly null the checkout token at session start. clearOrder() already does this,
  // but an in-flight persistCartData response can land after clearOrder() and write the
  // token back — this ensures no stale token carries into the next customer's session
  // (ECOMM-10535 / ECOMM-9943).
  // Session.reset() generates a fresh session ID for analytics/flags on each new customer.
  useEffect(() => {
    Cart?.setCheckoutToken(null);
    Session.getInstance().reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return isKioskProEnabled ? <KioskProLockScreen /> : <LockScreen />;
}
